import { UIColor } from '@prishapolicy/shared/ui';

export const badgeTagsMap: {
  [key: string]: UIColor | 'grey';
} = {
  Health: 'green',
  Insurance: 'red',
  New: 'blue',
  'Cyber Insurance': 'yellow',
  Other: 'grey',
  Motor: 'teal',
  'Liability':'teal',
  'Basics':"purple",
  'New Trends':"blue",
  'Regulation':"yellow",
  'Case Study':"green",
  'Money':"green",
  'Liability Insurance':'teal',
  'Mothers Day':"red"
};
export type BadgeTagMap = keyof typeof badgeTagsMap;
